'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemField } from './cart-item-field.component';
import { CartItemHeader } from './cart-item-header.component';
import { CartItemProcedure } from './cart-item-procedure.component';
import { CartItemRemoveButton } from './cart-item-remove-button.component';
import { CartItemWarning } from './cart-item-warning.component';
import { CartItemProps } from './cart-item.types';

import { hasCartItemDiscount } from '@/utils/cart/get-cart-total.util';
import { formatCartItemSchedule } from '@/utils/cart/format-cart-item-schedule.util';
import { formatSimpleAddress } from '@/utils/formatters/format-address';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

export function CartItem({
  item,
  warning,
  onEditSchedule,
  onEditPatient,
  onRemove,
}: CartItemProps) {
  const schedule = formatCartItemSchedule(item.slot);
  const patientName = formatToTitleCase(item.patient.socialName || item.patient.legalName);

  const showLocation = !item.procedure.isTelehealth;
  const locationAddress = formatSimpleAddress(item.partner.facility);

  return (
    <article
      className="flex flex-col gap-2 rounded-xxl border border-gray-300 bg-white p-4"
      data-testid={DataTestIdEnum.CART_ITEM}
    >
      <CartItemHeader item={item} />

      <CartItemProcedure item={item} />

      {!hasCartItemDiscount(item) && <hr className="border-t border-gray-300" />}

      {schedule && (
        <CartItemField
          label="Data e hora"
          value={<span>{schedule}</span>}
          dataTestId={DataTestIdEnum.CART_ITEM_FIELD_SCHEDULE}
          action={onEditSchedule && {
            label: 'Alterar data e hora',
            dataTestId: DataTestIdEnum.CART_ITEM_EDIT_SCHEDULE_BUTTON,
            onClick: onEditSchedule,
          }}
        />
      )}

      {warning && <CartItemWarning>{warning}</CartItemWarning>}

      <CartItemField
        label="Atendimento para"
        value={<span>{patientName}</span>}
        dataTestId={DataTestIdEnum.CART_ITEM_FIELD_PATIENT}
        action={onEditPatient && {
          label: 'Alterar paciente',
          dataTestId: DataTestIdEnum.CART_ITEM_EDIT_PATIENT_BUTTON,
          onClick: onEditPatient,
        }}
      />

      {showLocation && (
        <CartItemField
          label="Local"
          dataTestId={DataTestIdEnum.CART_ITEM_FIELD_LOCATION}
          value={(
            <>
              <span>{formatToTitleCase(item.partner.facility.name)}</span>
              <span>{locationAddress}</span>
            </>
          )}
        />
      )}

      {onRemove && <CartItemRemoveButton onRemove={onRemove} />}
    </article>
  );
}
